export default __webpack_public_path__ + "static/media/me0.3a4963ec.gif";